// extracted by mini-css-extract-plugin
export default {"addressSection":"aT-z","disabled":"bT-z","sectionButtons":"cT-z","logo":"dT-z"};